import { useEffect, useRef, useState } from "react";

export default function GenericCasinoTimer({ time, status }) {
  const parsedTime = parseInt(time) || 0;
  const [timeLeft, setTimeLeft] = useState(parsedTime);
  const intervalRef = useRef(null);
  const initialTimeRef = useRef(parsedTime);
  const radius = 20;
  const stroke = 3;
  const normalizedRadius = radius - stroke * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;
  const progress = timeLeft / initialTimeRef.current;
  const strokeDashoffset = circumference * (1 - progress);

  const startTimer = () => {
    // Clear any existing interval first
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    // Set initial time
    setTimeLeft(initialTimeRef.current);

    // Start new interval
    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Effect to handle timer
  useEffect(() => {
    // Update initial time when time prop changes
    const newTime = parseInt(time) || 0;
    initialTimeRef.current = newTime;

    // Handle status changes
    if (status === "ONLINE") {
      setTimeLeft(newTime);
      startTimer();
    } else if (status === "SUSPEND") {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      setTimeLeft(0);
    }
  }, [time, status]);

  return (
    <div className="flex flex-col items-center space-y-4">
      <svg height={radius * 2} width={radius * 2}>
        <circle
          stroke="#eee"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke="green"
          fill="transparent"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference + " " + circumference}
          strokeDashoffset={strokeDashoffset}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          style={{ transition: `stroke-dashoffset 1s linear` }}
        />
        <text
          x="50%"
          y="50%"
          dy=".3em"
          textAnchor="middle"
          fontSize="12px"
          fill="white"
        >
          {timeLeft}
        </text>
      </svg>
    </div>
  );
}
